<template>
  <div class="file-picker">
    <div class="d-flex justify-content-between">
      <span class="file-picker__name">{{fileName}}</span>
      <span>{{extension}}</span>
    </div>
    <span v-if="isEdited" class="file-picker__close" @click="onRemove">
      <i class="el-icon-close"></i>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    isEdited: {
      type: Boolean,
      required: true,
    },
    file: {
      type: Object,
      required: false,
    },
  },

  computed: {
    fileName() {
      return this.file?.fileName?.split(/(?=\.[^.]*$)/)?.[0] ?? '';
    },
    extension() {
      return this.file?.fileName?.split(/(?=\.[^.]*$)/)?.[1]?.slice(1) ?? '';
    },
  },

  methods: {
    onRemove() {
      this.$emit('onRemove', this.file);
    },
  },

};
</script>
